module.exports = __webpack_public_path__ + "img/Capricorn.630ba0d6.svg";